<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Walking Wolf</span></p>
<p class="bk-title1"><span>A Weird Western</span></p>
<p class="authorname"><span>Nancy A. Collins</span></p>
<p class="authorname"><img alt="logo" src="images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?a2b24aba